import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function PrincipalsWelcome() {
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section with Principal's Quote */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-10">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    🎓 PRINCIPAL'S MESSAGE
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  Welcome to DTK College
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.8rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300',
                  fontStyle: 'italic'
                }}>
                  To be the best, get the best!
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        <section id="principals-welcome" className="principals-welcome section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            {/* Welcome Message Box */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  overflow: 'hidden',
                  border: '1px solid #e2e8f0'
                }} data-aos="fade-up" data-aos-delay="100">
                  
                  {/* Content Section */}
                  <div style={{ padding: '50px' }}>
                    <div style={{ fontSize: '1.05rem', lineHeight: '1.9', color: '#475569' }}>
                      <p className="mb-4" style={{ textAlign: 'justify' }}>
                        <span style={{ 
                          fontSize: '4rem', 
                          float: 'left', 
                          lineHeight: '0.8', 
                          marginRight: '15px',
                          marginTop: '8px',
                          color: '#7B3F9E', 
                          fontWeight: '700',
                          fontFamily: 'Georgia, serif'
                        }}>I</span>
                        t is my great pleasure to welcome you to DTK College, a place where ambition, opportunity 
                        and diversity come together to create an inspiring learning experience. From your very 
                        first contact with us, you can expect a warm, friendly and welcoming experience. At DTK 
                        College, we are committed to creating an environment where every student feels valued, 
                        supported and encouraged to achieve their full potential.
                      </p>
                      
                      <h3 style={{ 
                        fontSize: '1.4rem', 
                        fontWeight: '700', 
                        color: '#7B3F9E', 
                        marginBottom: '15px',
                        letterSpacing: '-0.3px'
                      }}>
                        A College with a Longstanding and Strong Reputation
                      </h3>
                      <p className="mb-4" style={{ textAlign: 'justify' }}>
                        DTK College has built an <strong style={{ color: '#7B3F9E' }}>enviable reputation, supported 
                        by our commitment to high standards and strong achievement.</strong> Our results reflect 
                        the dedication of our students and staff and our determination to provide an excellent 
                        educational experience.
                      </p>
                      
                      {/* Highlighted Section */}
                      <div style={{ 
                        padding: '30px',
                        background: 'linear-gradient(135deg, #F5EBFA 0%, #dcfce7 100%)',
                        borderRadius: '16px',
                        border: '2px solid #D4BFE3',
                        marginBottom: '30px',
                        position: 'relative'
                      }}>
                        <div style={{
                          position: 'absolute',
                          top: '-15px',
                          left: '30px',
                          backgroundColor: '#7B3F9E',
                          color: 'white',
                          padding: '5px 20px',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          letterSpacing: '0.5px'
                        }}>
                          OUR COURSES
                        </div>
                        <p style={{ 
                          textAlign: 'center',
                          fontSize: '1.1rem',
                          fontWeight: '600',
                          color: '#6B2F8E',
                          marginBottom: 0,
                          marginTop: '10px'
                        }}>
                          We offer a diverse range of apprenticeships and further education courses, carefully 
                          selected to provide relevant knowledge, practical skills and valuable qualifications 
                          for today's changing world.
                        </p>
                      </div>
                      
                      <p className="mb-4" style={{ textAlign: 'justify' }}>
                        Whether you are preparing for further study, developing your career or taking the next 
                        important step towards your ambitions, our courses are designed to help you move forward 
                        with confidence and purpose.
                      </p>
                      
                      <h3 style={{ 
                        fontSize: '1.4rem', 
                        fontWeight: '700', 
                        color: '#7B3F9E', 
                        marginBottom: '15px',
                        letterSpacing: '-0.3px'
                      }}>
                        Our Students Make Us Who We Are
                      </h3>
                      <p className="mb-4" style={{ textAlign: 'justify' }}>
                        At DTK College, we recognise that our greatest strength is our students. We value and 
                        respect the unique experiences, perspectives, cultures and aspirations that every student 
                        brings to our college community. Our diverse student body contributes enormously to the 
                        continued growth and development of DTK. We are proud to be part of this community and to 
                        play our role in supporting the educational, personal and professional development of our 
                        students.
                      </p>
                      
                      <p className="mb-4" style={{ textAlign: 'justify' }}>
                        At DTK College, we believe that every student has the potential to achieve, grow and make 
                        a positive difference.
                      </p>
                      
                      {/* Call to Action Quote */}
                      <div style={{
                        textAlign: 'center',
                        padding: '40px 30px',
                        background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                        borderRadius: '16px',
                        marginBottom: '40px',
                        boxShadow: '0 10px 30px rgba(123, 63, 158, 0.3)'
                      }}>
                        <div style={{ fontSize: '3rem', marginBottom: '15px' }}>🎓</div>
                        <p style={{ 
                          fontSize: '1.5rem',
                          fontWeight: '700',
                          color: 'white',
                          marginBottom: 0,
                          fontStyle: 'italic',
                          letterSpacing: '-0.5px'
                        }}>
                          Choose DTK today, and you won't look back!
                        </p>
                      </div>
                      
                      {/* Signature Section */}
                      <div style={{
                        borderTop: '2px solid #e2e8f0',
                        paddingTop: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}>
                        <div style={{ flex: 1 }}>
                          <div style={{
                            width: '80px',
                            height: '80px',
                            backgroundColor: '#F5EBFA',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '3px solid #7B3F9E',
                            fontSize: '2.5rem'
                          }}>
                            👨‍🎓
                          </div>
                        </div>
                        <div style={{ flex: 3, textAlign: 'right' }}>
                          <p style={{ 
                            fontSize: '1.3rem', 
                            fontWeight: '700', 
                            color: '#1e293b', 
                            marginBottom: '5px',
                            letterSpacing: '-0.3px'
                          }}>
                            John 'Kunle Ayeni
                          </p>
                          <p style={{ 
                            fontSize: '1rem', 
                            color: '#7B3F9E', 
                            fontWeight: '600',
                            marginBottom: 0
                          }}>
                            Principal, DTK College
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Mission and Vision Cards */}
            <div className="row justify-content-center mb-5" data-aos="fade-up" data-aos-delay="200">
              <div className="col-lg-10">
                <div className="row gy-4">
                  <div className="col-lg-6">
                    <div className="h-100 shadow-lg" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      transition: 'all 0.3s ease',
                      border: '1px solid #e2e8f0'
                    }} onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(123, 63, 158, 0.2)';
                    }}
                       onMouseOut={(e) => {
                         e.currentTarget.style.transform = 'translateY(0)';
                         e.currentTarget.style.boxShadow = '';
                       }}>
                      {/* Card Header */}
                      <div style={{
                        background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                        padding: '40px 40px 50px',
                        position: 'relative'
                      }}>
                        <div style={{
                          position: 'absolute',
                          bottom: '-40px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: '90px',
                          height: '90px',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                          border: '4px solid #F5EBFA'
                        }}>
                          <i className="bi bi-bullseye" style={{ fontSize: '2.8rem', color: '#7B3F9E' }}></i>
                        </div>
                      </div>
                      
                      {/* Card Body */}
                      <div style={{ padding: '60px 40px 40px' }}>
                        <h3 className="mb-4 text-center" style={{ 
                          fontSize: '1.8rem', 
                          fontWeight: '700', 
                          color: '#1e293b',
                          letterSpacing: '-0.5px'
                        }}>
                          Our Mission
                        </h3>
                        <p style={{ 
                          fontSize: '1.05rem', 
                          lineHeight: '1.8', 
                          color: '#64748b', 
                          textAlign: 'center',
                          marginBottom: 0
                        }}>
                          Our mission is to be a leading training provider delivering excellent teaching and 
                          supporting our students in their learning by building their knowledge and skills for 
                          a changing world.
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-lg-6">
                    <div className="h-100 shadow-lg" style={{ 
                      backgroundColor: '#fff',
                      borderRadius: '20px',
                      overflow: 'hidden',
                      transition: 'all 0.3s ease',
                      border: '1px solid #e2e8f0'
                    }} onMouseOver={(e) => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.boxShadow = '0 20px 40px rgba(123, 63, 158, 0.2)';
                    }}
                       onMouseOut={(e) => {
                         e.currentTarget.style.transform = 'translateY(0)';
                         e.currentTarget.style.boxShadow = '';
                       }}>
                      {/* Card Header */}
                      <div style={{
                        background: 'linear-gradient(135deg, #6B2F8E 0%, #475569 100%)',
                        padding: '40px 40px 50px',
                        position: 'relative'
                      }}>
                        <div style={{
                          position: 'absolute',
                          bottom: '-40px',
                          left: '50%',
                          transform: 'translateX(-50%)',
                          width: '90px',
                          height: '90px',
                          backgroundColor: 'white',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                          border: '4px solid #F5EBFA'
                        }}>
                          <i className="bi bi-lightbulb" style={{ fontSize: '2.8rem', color: '#6B2F8E' }}></i>
                        </div>
                      </div>
                      
                      {/* Card Body */}
                      <div style={{ padding: '60px 40px 40px' }}>
                        <h3 className="mb-4 text-center" style={{ 
                          fontSize: '1.8rem', 
                          fontWeight: '700', 
                          color: '#1e293b',
                          letterSpacing: '-0.5px'
                        }}>
                          Our Vision
                        </h3>
                        <p style={{ 
                          fontSize: '1.05rem', 
                          lineHeight: '1.8', 
                          color: '#64748b', 
                          textAlign: 'center',
                          marginBottom: 0
                        }}>
                          Our vision is to develop the abilities and skills of our students by preparing them 
                          in a safe, effective, and inclusive learning environment to achieve their full capacities.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default PrincipalsWelcome;